import React, {useState, useEffect} from 'react';
import { getPresentationInit, updateTopicCompCol } from '../../utils/api-services/topic';

const PresentationEditor = ({obj, close}) => {

  const [titleSize, setTitleSize] = useState("");
  const [textSize, setTextSize] = useState("");
  const [zoom, setZoom] = useState("");
  const [animation, setAnimation] = useState("zoom");
  const [duration, setDuration] = useState("0.5");
  const [frmMsg, setFrmMsg] = useState("");
  const [posting, setPosting] = useState(false);

  useEffect(()=>{
    presetForm();
  }, []);

  function presetForm(){
    if(obj.Presentation != ""){
      const ptn = JSON.parse(obj.Presentation);
      setTitleSize(ptn.TitleSize);
      setTextSize(ptn.TextSize);
      setZoom(ptn.Zoom);
      setAnimation(ptn.Animation);
      setDuration(ptn.Duration);
    }
  }

  function updateInput(type, val){

    let ptn = { 
      TitleSize: titleSize, 
      TextSize: textSize, 
      Zoom: zoom, 
      Animation: animation,
      Duration: duration
    }

    if(type == "title"){
      setTitleSize(val);
      ptn.TitleSize = val;
    }
    else if(type == "text"){
      setTextSize(val);
      ptn.TextSize = val;
    }
    else if(type == "zoom"){
      setZoom(val);
      ptn.Zoom = val;
    }
    else if(type == "animation"){
      setAnimation(val);
      ptn.Animation = val;
    }
    else if(type == "duration"){
      setDuration(val);
      ptn.Duration = val;
    }

    obj.Presentation = JSON.stringify(ptn);
  }

  const apply = async () => {

    setFrmMsg("");

    if(animation == ""){
      setFrmMsg("Please select anumation");
      return;
    }

    if(duration == ""){
      setFrmMsg("Please select duration");
      return;
    }

    const value = {
      TitleSize: (titleSize != "")? titleSize: "",
      TextSize: (textSize != "")? textSize: "",
      Zoom: (zoom != "")? zoom: "",
      Animation: (animation != "")? animation: "",
      Duration: (duration != "")? duration: ""
    }

    const saveRecord = await updateTopicCompCol({
      id: obj.Id,
      column: 'presentation',
      value: JSON.stringify(value)
    });

    if(saveRecord.Success){
      const startComp = await getPresentationInit(obj.TopicSlug);
      if(startComp != null){
        location.reload(); //close();
      }
    }

  }

  const styles = {   
    item: {
      
    },
    label:{
      color: "#999",
      fontSize: 12,
      fontWeight: 500
    },
    input:{
      border: '1px solid #999',
      outline: 'none',
      boxShadow: 'none',
      transition: 'none',
    },
    applyBtn:{
      width: '100%',
    },
    frmMsg:{
      color: '#ff0000',
      fontSize: 13
    }
  }

  return(
    <div style={styles.form}>

      <div className='row'>

      <div className='col-6 col-md-4 form-group'>
        <label style={styles.label}>TITLE SIZE</label>
        <input type='number' value={titleSize} onChange={e => updateInput('title', e.target.value)} style={styles.input} className="form-control form-control-sm" placeholder='Enter title size' />                
      </div>

      <div className='col-6 col-md-4 form-group'>
        <label style={styles.label}>TEXT SIZE</label>
        <input type='number' value={textSize} onChange={e => updateInput('text', e.target.value)} style={styles.input} className="form-control form-control-sm" placeholder='Enter text size' />                
      </div>

      <div className='col-6 col-md-4 form-group'>
        <label style={styles.label}>ZOOM</label>
        <input type='number' value={zoom} onChange={e => updateInput('zoom', e.target.value)} style={styles.input} className="form-control form-control-sm" placeholder='Enter text size' />                
      </div>

      <div className="col-6 col-md-4 form-group">
        <label style={styles.label}>ANIMATION</label>
        <select value={animation} onChange={e => updateInput('animation', e.target.value)} style={styles.input} className="form-control form-control-sm">
          <option key={1} value={"zoom"}>Zoom</option>
          <option key={2} value={"left-right-slide"}>Left To Right Slide</option>
          <option key={2} value={"right-left-slide"}>Right To Left Slide</option>
          <option key={2} value={"bottom-up-slide"}>Bottom To Top Slide</option>
        </select>
      </div>

      <div className="col-6 col-md-4 form-group">
        <label style={styles.label}>ANIMATION DURATION</label>
        <select value={duration} onChange={e => updateInput('duration', e.target.value)} style={styles.input} className="form-control form-control-sm">
          <option key={1} value={"0.5"}>0.5</option>
          <option key={2} value={"1"}>1</option>
          <option key={2} value={"1.5"}>1.5</option>
          <option key={2} value={"2"}>2</option>
        </select>
      </div>

      {(frmMsg != "") &&
        <div style={styles.frmMsg} className='col-12 form-group'>{frmMsg}</div>
      }

      </div>

      <hr />

      <button onClick={apply} style={styles.applyBtn} className='btn btn-sm btn-primary'>SAVE</button>

    </div>
  )
    
}

export default PresentationEditor;